import { render, staticRenderFns } from "./TheMarks.vue?vue&type=template&id=27776280&"
import script from "./TheMarks.vue?vue&type=script&lang=js&"
export * from "./TheMarks.vue?vue&type=script&lang=js&"
import style0 from "./TheMarks.vue?vue&type=style&index=0&id=27776280&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports